export const updateInternalSearchSessionStorage = (updatedSessionStorage) => {
  sessionStorage.setItem(
    "internal_search_session_storage",
    JSON.stringify({
      ...JSON.parse(sessionStorage.getItem("internal_search_session_storage")),
      ...updatedSessionStorage,
    })
  )
}
